module.exports = __webpack_public_path__ + "img/12_klio_10.35919204.jpg";